import React from 'react';
import GiphyViewer from '../viewer/giphy-viewer.js';
import 'wix-rich-content-common';
import '../giphy-viewer-05f5e991.js';
import '../style-inject.es-746bb8ed.js';
import 'ricos-context';

const Gif = ({ settings, componentData }) => {
  return /* @__PURE__ */ React.createElement(GiphyViewer, { componentData, settings });
};

export { Gif };
//# sourceMappingURL=component.js.map
